import axios from "axios";
// import { useDispatch } from "react-redux";
import { logoutThunk } from "../redux/slices/authSlice";
import store from "../redux/store";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
  headers: {
    "Content-Type": "application/json",
  },
});
// Add a request interceptor
// api.interceptors.request.use(
//   async (config) => {
//     // Check if knowledge_token is in localStorage
//     const knowledgeToken = localStorage.getItem("knowledge_token");
//     // const dispatch = useDispatch();

//     if (!knowledgeToken) {
//       // Dispatch logoutThunk if knowledge_token is missing
//       await store
//         .dispatch(logoutThunk(process.env.REACT_APP_LOGIN_REDIRECT_URL))
//         .unwrap();
//       return Promise.reject(
//         new Error("knowledge_token is missing. Logging out.")
//       );
//     }

//     // Set Authorization header if the token exists
//     config.headers.Authorization = `Token ${knowledgeToken}`;
//     return config;
//   },
//   (error) => {
//     return Promise.reject(error);
//   }
// );

export default api;
